const KEY = 'nuyed_theme';
export const THEMES = ['dark', 'light'];
const META_COLOR = { dark: '#070A13', light: '#EEF1F6' };

export function getTheme() {
  try { return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
}

export function applyTheme(t) {
  const theme = t === 'light' ? 'light' : 'dark';
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  root.style.colorScheme = theme;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', META_COLOR[theme]);
  try { localStorage.setItem(KEY, theme); } catch {}
  window.dispatchEvent(new CustomEvent('nuyed:theme', { detail: { theme } }));
  return theme;
}
